import { render } from "./StarIcon2.vue?vue&type=template&id=7458f9b7"
import script from "./StarIcon2.vue?vue&type=script&lang=js"
export * from "./StarIcon2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__